<script setup lang="ts">
</script>

<template>
  <div class="min-h-screen bg-surface flex items-center justify-center p-6">
    <div class="w-full max-w-md">
      <slot />
    </div>
  </div>
</template>
